"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIRM_BTN_IN_TEMPLATE_MODAL = exports.USE_TEMPLATE_BTN = exports.TOP_HOT_BANNER = void 0;
/* eslint-disable */
// id of the template center
const TEMPLATE_CENTER_PREFIX = 'TEMPLATE_CENTER_';
exports.TOP_HOT_BANNER = TEMPLATE_CENTER_PREFIX + 'TOP_HOT_BANNER'; // The most popular banner in the template center
exports.USE_TEMPLATE_BTN = TEMPLATE_CENTER_PREFIX + 'USE_TEMPLATE_BTN'; // "Use Template" button
exports.CONFIRM_BTN_IN_TEMPLATE_MODAL = TEMPLATE_CENTER_PREFIX + 'CONFIRM_BTN_IN_TEMPLATE_MODAL'; // use the confirmation button in the template confirmation box
//# sourceMappingURL=template_center_id.js.map